import Component from './Button'

export default Component
